import { Container, Text, Box } from "@chakra-ui/react";
import Content from "./Content";
import Navbar from "./Navbar";

function NotFound() {
  return (
    <div>
      <Navbar />
      <Container minW="full" height="482px">
        <Box
          style={{
            color: "#26a9e1",
            textShadow: "2px 2px 4px #000000",
            marginTop: "200px",
          }}
        >
          <Text fontSize="7xl" as="b">
            404 Error
          </Text>
        </Box>
        <Box style={{ color: "white", textShadow: "2px 2px 4px #000000" }}>
          <Text fontSize="4xl" as="b">
            Sorry, Page Not Fount
          </Text>
        </Box>
      </Container>
      <Content />
    </div>
  );
}
export default NotFound;
